import React, { useMemo } from 'react';
import DailySalesCharts from './DailySalesCharts';
import PopularProductsCharts from './PopularProductsCharts';
import EmployeesSalesCharts from './EmployeesSalesCharts';

export const getChartsComponent = (statisticType) => {
  switch (statisticType) {
    case 'DAILY_SALES':
      return DailySalesCharts;
    case 'POPULAR_PRODUCTS':
      return PopularProductsCharts;
    case 'EMPLOYEES_SALES':
      return EmployeesSalesCharts;
    default:
      return () => <></>;
  }
};

export const moneyNumberFormatter = new Intl.NumberFormat(undefined, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});